// export const BASE_URL =
//   process.env.NODE_ENV === 'develeopment' ? 'http://localhost:5000' : '';
export const BASE_URL = ''; // If using proxy
export const COACHINGCENTER_URL = '/api/coachingcenter';
export const USERS_URL = '/api/users';
export const EXCELUPLOADS_URL = '/api/exceluploads';
export const QUESTIONS_URL = '/api/questions';
export const QUIZATTEMPTS_URL = '/api/quizattempts';
export const QUIZ_URL = '/api/quiz';
export const SUBJECTS_URL = '/api/subjects';
export const QUESTION_IMAGES_URL = "/api/question-images";
export const QUIZ_IMAGES_URL = "/api/quiz-images";
export const QUIZZES_URL = "/api/quizzes";
export const QUESTION_BANK_SUBJECTS_URL = "/api/question-bank-subjects"
export const QUIZ_QUESTION_URL = '/api/quiz-questions';
export const CHAPTER_URL = '/api/chapters';
export const BILLING_URL = '/api/billing';
export const BILLINGDASHBOARD_URL = '/api/billingdashboard';
export const COACHINGCENTERBILLING = '/api/coachingcenterbillings';

export const ENGLISHQUIZ_URL = '/api/english-quiz';
export const ENGLISHQIESBLUEPRINT_URL = '/api/english-quiz-blueprint';
export const ENGLISHQUESTION_URL = "/api/english-questions";
export const ENGLISHQUESTIONGROUP_URL = "/api/english-question-group";
export const ENGLISHQUIZATTEMPT_URL = "/api/english-quiz-attempt";
